import { useTu } from "@src/appV2/i18n/useTu";
import { useTheme } from "@mui/material/styles";
import { Text } from "@src/appV2/redesign/components/Text";
import { useDisplayTime } from "./useDisplayTime";

export interface LocalTimeProps {
  timeZone?: string;
  /**
   * Text color override. Defaults to the navbar content color — preserved so
   * the admin header keeps its original look. Surfaces outside the navbar
   * (sidebars, cards) should pass a color that fits their background.
   */
  color?: string;
}

export function LocalTime(props: LocalTimeProps) {
  const { tu } = useTu("common");

  const { timeZone, color } = props;
  const localTime = useDisplayTime({ timeZone });
  const theme = useTheme();
  const effectiveColor = color ?? theme.palette.navbar?.itemContent;

  return (
    <Text variant="body2" sx={{ color: effectiveColor }}>
      {tu("Local time: {{localTime}}", { values: { localTime: localTime ?? "" } })}
      {timeZone ? ` (${timeZone}) ` : null}
    </Text>
  );
}
